const authLib = {
  authClient: {},
  init: (client) => {
    authLib.authClient = client;
  },
};

export default authLib;
